import React from 'react';

const Home = () => {
    return <h1 className="home">Bienvenido</h1>;
};

export default Home;
